import React from 'react';
import { greenIcon, getJsonValue } from '../DetailComponents/utils';

const jv = (item, field, def) => getJsonValue(item, field, def);

export const arbolConfig = {
  id: 'arbol',
  label: 'Arbolado Urbano',
  regex: /arbol|arboles|rbol|arbo/,
  autoHeatmap: false,
  icon: greenIcon,
  jsonFields: [
    { key: 'poda', label: 'Requiere Poda', type: 'bool' },
    { key: 'arbol_altura_maxima', label: 'Altura > 15m', type: 'bool' },
  ],
  renderExtraInfo: (item) => (
    <div className="d-flex gap-1 mt-1">
      {jv(item, 'poda') == 1 && <span className="badge bg-warning text-dark" style={{ fontSize: '0.5rem' }}>PODA</span>}
      {jv(item, 'arbol_altura_maxima') == 1 && <span className="badge bg-info text-white" style={{ fontSize: '0.5rem' }}>+15m</span>}
    </div>
  ),
  subFilters: [
    { id: 'poda', label: 'Poda', check: (m) => jv(m, 'poda') == 1 },
    { id: 'altura', label: 'Altura Elevada', check: (m) => jv(m, 'arbol_altura_maxima') > 0 }
  ],
  calculatePriority: () => 'Baja',
  calculateCompany: () => 'N/A',
  summaryConfig: {
    showCompanyKPI: false,
    showPriorityKPI: false,
    mainChart: 'sub-categories'
  },
  hasPriority: false,
  hasCompany: false
};
